<template>
    <v-container class="pa-5 d-flex flex-column" fluid style="height: 100%">
        <page-title>
            Zamówienia nadane w czasie
        </page-title>
        <v-row align="center">
            <v-col class="pb-6">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-card
            width="100%"
            height="100%"
            class="d-flex flex-column"
            :loading="actionLoading.getSentOrdersByDate"
        >
            <v-card-text style="height: 99%; width: 100%; position: relative">
                <canvas ref="chartContainer" />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'

import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'

import { errorHandler } from '@/utils/errorHandler'

import { Chart, BarController, CategoryScale, LinearScale, BarElement, Tooltip } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

export default {
    name: 'SentOrdersSimple',
    components: {
        PageTitle,
    },
    mixins: [ dateFormatter, tooltipDelay ],
    data() {
        return {
            chart: null,
            chartData: {
                labels: ['0:00', '1:00', '2:00',
                    '3:00', '4:00', '5:00',
                    '6:00', '7:00', '8:00',
                    '9:00', '10:00', '11:00',
                    '12:00', '13:00', '14:00',
                    '15:00', '16:00', '17:00',
                    '18:00', '19:00', '20:00',
                    '21:00', '22:00', '23:00',
                ],
                data: new Array(24) //An array need to be intialized with same length labels have
            },
            menuFrom: false,
            actionLoading: {
                getSentOrdersByDate: false,
                generateReport: false
            },
            labelsHourly: [
                '0:00', '1:00', '2:00',
                '3:00', '4:00', '5:00',
                '6:00', '7:00', '8:00',
                '9:00', '10:00', '11:00',
                '12:00', '13:00', '14:00',
                '15:00', '16:00', '17:00',
                '18:00', '19:00', '20:00',
                '21:00', '22:00', '23:00',
            ],
        }
    },
    computed: {
        filterQuery() {
            let date = new Date()
            let query = `date=${date.toISOString().split('T')[0]}`

            return query
        },
    },
    mounted() {
        this.setDiagram()
        this.getSentOrdersByDate()
    },
    destroyed() {
        this.chart.destroy()
    },
    methods: {
        async getSentOrdersByDate() {
            this.resetChart()
            this.actionLoading.getSentOrdersByDate = true

            return await this.$store.dispatch('reportsAndAnalysis/orders/getSentOrdersByDate', {
                query: this.filterQuery
            })
                .then(response => {
                    this.setChartData(response.data.results)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.getSentOrdersByDate = false
                })
        },
        setDiagram() {
            Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip, ChartDataLabels)

            const chartContainer = this.$refs.chartContainer

            this.chart = new Chart(chartContainer, {
                type: 'bar',
                plugins: [ChartDataLabels],
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 20
                        }
                    },
                    scales: {
                        y: {
                            suggestedMax: 70,
                            beginAtZero: true,
                            ticks: {
                                stepSize: 10
                            }
                        }
                    },
                    plugins: {
                        datalabels: {
                            display(context) {
                                return context.dataset.data[context.dataIndex] > 0
                            },
                            anchor: 'end',
                            align: 'end',
                            offset: 4,
                            font: {
                                weight: 'bold',
                                size: 14
                            },
                        },
                        legend: {
                            display: false
                        }
                    }
                },
                data: {
                    labels: this.chartData.labels,
                    datasets: [{
                        label: 'Ilość zamówień',
                        data: this.chartData.data,
                        backgroundColor: '#2196F3',
                        borderWidth: 0,
                        borderRadius: 5,
                    }]
                },
            })
        },
        resetChart() {
            this.chartData.labels = this.labelsHourly
            this.chartData.data = []
            this.chart.data.labels = this.chartData.labels
            if (this.$refs.chartContainer) this.chart.update()
        },
        setChartData(ordersByHour) {
            this.chartData.data = [...new Array(24)].map((item, index) => {
                const hour = ordersByHour.find(item => item.hour === index)

                return typeof hour !== 'undefined' ? hour.count : 0
            })

            this.chart.data.datasets[0].data = this.chartData.data

            this.setColor(this.chart.data.datasets[0].data)

            if (this.$refs.chartContainer) this.chart.update()
        },
        setColor(dataset) {
            this.chart.data.datasets[0].backgroundColor = []
            dataset.forEach(item => {
                if (item <= 50) {
                    this.chart.data.datasets[0].backgroundColor.push('#ff1a1a')
                } else if (item <= 100) {
                    this.chart.data.datasets[0].backgroundColor.push('#ff751a')
                } else {
                    this.chart.data.datasets[0].backgroundColor.push('#00cc44')
                }

            })
        },
        close() {
            this.$router.push({ name: 'reportingAndAnalysisOrdersOrders' })
                .catch(error => {
                    errorHandler(error)
                })
        },
    }
}
</script>